import React from 'react';
import { Wrapper, Head, HeadText, HeadPrice, HeadPriceNumber, HeadPriceText } from './styled';
import ItemCheckList from './ItemCheckList';

const CheckList = ({ title, total, list, isAuth, priceText, isSideBar, isPaddingText }) => {
    return (
        <Wrapper>
            <Head isSideBar={isSideBar}>
                <HeadText isSideBar={isSideBar}>{title}</HeadText>
                <HeadPrice isSideBar={isSideBar}>
                    {total && <HeadPriceNumber isSideBar={isSideBar}>{total}</HeadPriceNumber>}
                    {priceText && <HeadPriceText isSideBar={isSideBar}>{priceText}</HeadPriceText>}
                </HeadPrice>
            </Head>
            {
                list && list.map((item, key) => {
                    return (
                        <ItemCheckList
                            key={key + Math.random()}
                            name={item.name}
                            oldPrice={item.oldPrice}
                            period={item.period}
                            promoPeriod={item.promoPeriod}
                            price={!isAuth ? item.price : item.priceClient || item.price}
                            deleteItem={item.deleteItem}
                            priceText={priceText}
                            isSideBar={isSideBar}
                            onSelect={item.onSelect ? () => item.onSelect(key) : null}
                            selected={item.selected}
                            tooltip={item.tooltip}
                            isPaddingText={isPaddingText}
                            required={item.required}
                            materialsEnsId={item.materialsEnsId}
                        />
                    );
                })
            }
        </Wrapper>
    );
};

export default CheckList;
